<template>
  <div class="msg card">
    <div class="card-header msg__header">
      <p class="msg__header__title card-header-title">
        {{ message.title }}
      </p>
      <p class="msg__header__date is-unselectable" v-if="message.date">
        Opublikowano: {{ formattedDate }}
      </p>
    </div>
    <div class="msg__content card-content">
      <dynamic-content :content="message.content" />
    </div>
  </div>
</template>

<script>
import { prettyDate } from "%utils/date";

import { DynamicContent } from "%helpers";

export default {
  name: "message",

  components: {
    DynamicContent
  },

  props: {
    message: Object
  },

  computed: {
    formattedDate() {
      return prettyDate(this.message.date);
    }
  }
};
</script>

<style lang="scss" scoped>
.msg {
  background: $white;

  &__header {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    padding: 1rem 1.5rem;
    align-items: center;

    &__title {
      margin: 0 1rem 0 0;
      padding: 0;
    }

    &__date {
      font-size: 0.8rem;
      margin: 0;
      padding: 0;
    }
  }
}
</style>
